module.exports = __webpack_public_path__ + "static/img/pypt.cbf34b9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/homepage/components/img/pypt.jpg
// module id = iiwI
// module chunks = 1